import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import arrayMutators from 'final-form-arrays';
import { Form } from 'react-final-form';
import { propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
/**
 * Final Formのラッパーコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FinalForm = (props) => {
    const { className, initialValues, onSubmit, render, validate } = props;
    return (_jsx(Form, { className: className, initialValues: initialValues, mutators: Object.assign({}, arrayMutators), onSubmit: onSubmit, render: render, validate: validate }));
};
FinalForm.propTypes = {
    className: propStr(),
    initialValues: propShape(),
    onSubmit: propFunc().isRequired,
    render: propFunc().isRequired,
    validate: propFunc(),
};
FinalForm.defaultProps = {
    className: '',
    initialValues: undefined,
    validate: undefined,
};
export default FinalForm;
